import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import NotFound from "./pages/404";
import ServerError from "./pages/500";
import Loading from "./pages/FullPageLoading";

import {
  hostAgencyActions,
  isHostAgencyLoading,
  getHostAgencyError,
  isHostNotFound,
} from "./reducers";

const HostCheck = ({ children }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(hostAgencyActions.fetch());
  }, []);
  const isLoading = useSelector(isHostAgencyLoading);
  const isNotFound = useSelector(isHostNotFound);
  const error = useSelector(getHostAgencyError);

  if (isLoading) {
    return <Loading />;
  }

  if (isNotFound) {
    return <NotFound />;
  }

  if (error) {
    return <ServerError />;
  }

  return children;
};

export default HostCheck;
